var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MiniAppWizard',{attrs:{"tabItems":_vm.tabItems,"state":_vm.state,"finalResult":_vm.finalResult},on:{"updateState":[_vm.updateState,_vm.updateState],"on-mini-app-finished":function($event){return _vm.$emit('on-mini-app-finished')},"on-mini-app-cancel":function($event){return _vm.$emit('on-mini-app-cancel')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }